var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoActivate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 18,
    viewBox: "0 0 16.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28990",
    "data-name": "Group 28990",
    transform: "translate(-109.777 -217.428)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47682",
    "data-name": "Path 47682",
    d: "M125.778,226.668v-.01a1.009,1.009,0,0,0-1.038-.963,1.069,1.069,0,0,0-.741.288.957.957,0,0,0-.3.7v.052a.253.253,0,0,1-.26.246h0a.261.261,0,0,1-.237-.148.487.487,0,0,1-.022-.167v-1.218a1.043,1.043,0,0,0-2.082,0v1.287a.239.239,0,0,1-.075.174.268.268,0,0,1-.184.072.252.252,0,0,1-.258-.245v-2.52a1.043,1.043,0,0,0-2.082,0v2.519a.238.238,0,0,1-.076.174.266.266,0,0,1-.183.072.252.252,0,0,1-.259-.245v-5.6a.95.95,0,0,0-.3-.7,1.063,1.063,0,0,0-.734-.289,1.018,1.018,0,0,0-1.044.985v8.681a.245.245,0,0,1-.141.218.27.27,0,0,1-.118.027.267.267,0,0,1-.152-.047l-3.769-2.6a1.387,1.387,0,0,0-.8-.253,1.362,1.362,0,0,0-.941.367.6.6,0,0,0,0,.886l6.128,5.814a4.43,4.43,0,0,0,3.067,1.205h2.044a4.427,4.427,0,0,0,3.062-1.2,4.014,4.014,0,0,0,1.264-2.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47683",
    "data-name": "Path 47683",
    d: "M114.9,223.538V221.13a2.017,2.017,0,0,1,2.043-1.98h0a2.07,2.07,0,0,1,1.418.56,1.937,1.937,0,0,1,.617,1.42v1.16a2.086,2.086,0,0,1,.563-.076,2.023,2.023,0,0,1,.449.07,3.4,3.4,0,1,0-5.094,1.254Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoActivate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_activate.ace0b05b64cc4fa19714151323d455e7.svg";